<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="参数设置"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="220px">
      <template v-for="(item, index) in paramsList">
        <el-form-item
          :label="item.name + (item.specs.unit ? '(' + item.specs.unit + ')' : '') + '：'"
          :key="index"
        >
          <el-input-number
            v-model.trim="form.params[item.identifier]"
            :step="Number(item.specs.step)"
            step-strictly
            :placeholder="item.name"
            controls-position="right"
            :min="isNaN(item.specs.min) ? form.params[item.specs.min] : Number(item.specs.min)"
            :max="isNaN(item.specs.max) ? form.params[item.specs.max] : Number(item.specs.max)"
            v-if="
              item.dataType === 'int' || item.dataType === 'float' || item.dataType === 'double'
            "
          ></el-input-number>
          <Select
            style="width: 240px;"
            :placeholder="item.name"
            v-model="form.params[item.identifier]"
            :options="getSelect(item.specs.enumDesc)"
            v-if="item.dataType === 'enum'"
          >
          </Select>
          <el-input
            v-model.trim="form.params[item.identifier]"
            clearable
            :placeholder="item.name"
            v-if="item.dataType === 'string'"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button
        type="primary"
        @click="okBtn"
        v-loading.fullscreen.lock="fullLoading"
        element-loading-text="正在设置..."
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import Select from '@kaili/components/CommonForm/Select'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    ids: {
      type: String
    },
    assetId: {
      type: String
    }
  },
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        params: {}
      },
      paramsList: [],
      rules: {},
      paramsApi: this.$api.freezer.device_paramProperties,
      setApi: this.$api.freezer.device_paramSetting
    }
  },
  computed: {
    fullLoading() {
      return this.$store.state.fullLoading
    }
  },
  mounted() {
    this.queryParams()
  },
  methods: {
    queryParams() {
      let params = {
        assetId: this.assetId
      }
      this.$ajax.get(this.paramsApi, params).then((res) => {
        this.paramsList = []
        res.data.map((item) => {
          if (
            (item.identifier === 'tempRefSet' ||
              item.identifier === 'dewState' ||
              item.identifier === 'quickFreState' ||
              item.identifier === 'tempSet') &&
            item.accessMode.indexOf('w') > -1
          ) {
            this.paramsList.push(item)
          }
        })
        this.$nextTick(() => {
          if (this.detail) {
            this.getDetail()
          }
        })
      })
    },
    getSelect(obj) {
      let arr = []
      for (let i in obj) {
        arr.push({
          code: i,
          name: obj[i]
        })
      }
      return arr
    },
    getDetail() {
      const params = {
        id: this.ids
      }

      this.$ajax.get(this.$api.freezer.device_detail, params).then((res) => {
        // 判断是否有设定值
        if (res.data.shadow) {
          let obj = {}
          this.paramsList.map((item) => {
            obj[item.identifier] =
              item.dataType === 'int' || item.dataType === 'float' || item.dataType === 'double'
                ? Number(res.data.shadow[item.identifier])
                : res.data.shadow[item.identifier]
          })
          this.form.params = obj
        }
      })
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let param = {}
          let nowParams = JSON.parse(JSON.stringify(this.form.params))

          for (let i in nowParams) {
            if (nowParams[i] || nowParams[i] === 0) {
              param[i] = nowParams[i].toString()
            }
          }

          let params = {
            ids: this.ids,
            assetId: this.assetId,
            params: JSON.stringify(param)
          }

          this.$ajax.post(this.setApi, params).then(() => {
            if (this.detail) {
              this.$store.commit('SET_FULL_LOADING', true)
              setTimeout(() => {
                this.$store.commit('SET_FULL_LOADING', false)
                this.$message.success('参数设置成功')
                this.notBtn()
                this.$emit('getDetail')
              }, 3000)
            } else {
              this.$message.success('参数设置成功')
              this.notBtn()
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
